<template>
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M13.3333 4.66675H2.66659C1.93021 4.66675 1.33325 5.2637 1.33325 6.00008V12.6667C1.33325 13.4031 1.93021 14.0001 2.66659 14.0001H13.3333C14.0696 14.0001 14.6666 13.4031 14.6666 12.6667V6.00008C14.6666 5.2637 14.0696 4.66675 13.3333 4.66675Z"
            stroke="#230078" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        <path
            d="M10.6666 14V3.33333C10.6666 2.97971 10.5261 2.64057 10.2761 2.39052C10.026 2.14048 9.68687 2 9.33325 2H6.66659C6.31296 2 5.97383 2.14048 5.72378 2.39052C5.47373 2.64057 5.33325 2.97971 5.33325 3.33333V14"
            stroke="#404245" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    </svg>

</template>